import React, { Component } from 'react';
import './Header.css';
import smooch from './img/smooch.png';
import {firstName, lastName} from './Utils';

class Header extends Component {
 render() {
    var headerStyle = {
      backgroundImage: 'url(' + smooch + ')',
    };
    return (

      <div className="App-header row middle-xs center-xs" style={headerStyle} ref="header">
        <div className="col-lg-8 col-xs-12">
          <h1>{firstName()} ❤️ {lastName()}</h1>
          <h2>{this.props.caption}</h2>
          <h3>#AlexAndHanaDoAWedding</h3>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js